import { SelectInput, type SelectInputProps } from '@interxfi/design-system/components/input/select-input/select-input';
import { type FixedOptionInputBaseProps, useFixedOptionInputOptions } from './shared';

export type FixedOptionSelectInputProps<TValue extends string = string> = Omit<SelectInputProps, 'options'> & FixedOptionInputBaseProps<TValue>;

export function FixedOptionSelectInput<TValue extends string = string>({
  filter,
  i18nNamespace,
  i18nPrefix,
  i18nValueName,
  optionModifier,
  optionValues,
  sortByLabel,
  ...rest
}: FixedOptionSelectInputProps<TValue>) {
  const options = useFixedOptionInputOptions({
    filter,
    i18nNamespace,
    i18nPrefix,
    i18nValueName,
    optionModifier,
    optionValues,
    sortByLabel,
  });

  return <SelectInput options={options} {...rest} />;
}
